import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Events from "@/pages/Events";
import Shop from "@/pages/Shop";
import Donate from "@/pages/Donate";
import CheckoutSuccess from "@/pages/CheckoutSuccess";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/events" element={<Events />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/shop/success" element={<CheckoutSuccess />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
